import { render, staticRenderFns } from "./ServiceTypesRegistryEditForm.vue?vue&type=template&id=de46b414"
import script from "./ServiceTypesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./ServiceTypesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports